// extracted by mini-css-extract-plugin
export default {"empty-area":"index-module__empty-area___w_q5l","emptyArea":"index-module__empty-area___w_q5l"};